import React, { useEffect, useState } from "react"
import profile from "../images/profile.png"
import dropDown from "../images/dropdown2.png"
import help from "../images/help.png"
import dropUp from "../images/dropup.webp"
import "../styles/ShopSettings.css"
import { useLocation, useNavigate } from "react-router-dom"
import axios from "axios"
import { CameraOutlined } from '@ant-design/icons';
import { Button, CircularProgress } from "@mui/material"
import { Alert, Checkbox, Switch,Input } from "antd"
import TextArea from "antd/es/input/TextArea"

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'
import Map from "./map"
import LocationOnIcon from '@mui/icons-material/LocationOn';

const modules={
  toolbar:[
    [{header:[3,4,false] }],
    [{font:[] }],
    ["bold","italic","underline","strike","blockquote"],
    [
      {list: "ordered"},
      {list: "bullet"},
      { indent: "-1"},
      { indent: "+2"}
    ],
    ["link"]
  ]
 }


export default function ShopSettings({propsData}) {
    const location = useLocation()
    const [routes,setRoutes]=useState(location.pathname.split("/"))
    let [shop,GetShop]=useState({})

    let [checkRequest,hanldeCheckRequest]=useState(false)

    useEffect(()=>{
            axios.get(`${process.env.REACT_APP_URL}/api/shope/getEachShope/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
              console.log(res.data);
              GetShop(res.data)
            })
            .catch(error=>{
              //console.log(error);
            })
      },[propsData.equilizer])

      useEffect(()=>{
        axios.get(`${process.env.REACT_APP_URL}/api/shope/checkRequest/${routes[2]}`, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })
        .then(res=>{
          console.log(res.data);
          hanldeCheckRequest(res.data.msg)
        })
        .catch(error=>{
          //console.log(error);
        })
  },[propsData.equilizer])
      
      let [shop_name,handle_shop_name]=useState(shop?.shope_name)
      let [country,handle_country]=useState(shop?.country)
      let [description,handle_description]=useState(shop?.description)
      let [shop_type,handle_shop_type]=useState(shop?.shope_type)
      let [shop_adress,handle_shop_adress]=useState(shop?.Address||{})
      let [showMap,setShowMap]=useState(false)

      useEffect(()=>{
        setTimeout(()=>{
            handle_shop_name(shop?.shope_name)
            handle_country(shop?.country)
            handle_description(shop?.description)
            handle_shop_type(shop?.shope_type)
            handle_shop_adress(shop?.Address||{})

        },3000)
      },[shop])

      let [disableSave,handleDisableSave]=useState(true)
      useEffect(()=>{
          let isNull=!shop_name||!country||!description||!shop_type
          let isSame=shop_name===shop?.shope_name&&country===shop.country&&description===shop.description
             &&shop_type===shop.shope_type
          let isInvalid=shop_name?.length<3||description?.length<10||shop_type?.length<2||country?.length<1
          handleDisableSave(isNull||isSame||isInvalid)
      },[country,shop_name,description,shop_type])
      
      let [verifyForm,ShowVerifyForm]=useState(false)
      function hanldeVerifyPage(e){
          ShowVerifyForm(e.target.checked)
      }

      let[error,setError]=useState("")
      let[success,setSuccess]=useState("")
      let[loading,setLoading]=useState(false)
 

      const SaveChanges=()=>{
        setLoading(true)
        let values={
          shope_name:shop_name,
           id:shop._id,
           shope_type:shop_type,
           country:country,
           description:description
        }
        if(shop_adress?.name){
          values["name"]=shop_adress.name
          values["lat"]=shop_adress.lat
          values["lng"]=shop_adress.lng
        }
        console.log(values);
       axios
       .put(`${process.env.REACT_APP_URL}/api/shope/update`, values, {
         headers: {
           Authorization: `Bearer ${propsData.userData?.token}`,
           'Content-Type': 'multipart/form-data',
         },
       })

       .then((response) => {
         setLoading(false);
         propsData.setEquilizer(propsData.equilizer+2)
         console.log(response.data);
         setSuccess("Profile updated successfuly")
         setTimeout(() => {
          setSuccess('');
         }, 5000);
       })

       .catch((error) => {
         setLoading(false);
         //console.error(error);
         if (error.response) {
          setError(error.response.data.error||"Error occured please try again !!!");
         } else {
          setError('An error occurred. Please try again.');
         }
         setTimeout(() => {
          setError('');
         }, 5000);
       });
      }

      const[transferPage,handleTransferPage]=useState(false)
      const[abortPage,handleAbortPage]=useState(false)
      const[deletePage,handleDeletePage]=useState(false)
      
      let [recipantEmail,handleRecipantEmail]=useState("")
      let [allowTransfer,handleAllowTransfer]=useState(false)

      const AddRecipant=(e)=>{
        let {value}=e.target
       // console.log(value);
        handleRecipantEmail(value)
        axios.get(`${process.env.REACT_APP_URL}/api/shope/checkUserToRecieve/${value}`, {
          headers: {
            Authorization: `Bearer ${propsData.userData?.token}`,
            'Content-Type': 'multipart/form-data',
          },
        })
 
        .then((response) => {
           
          handleAllowTransfer(true);
        })
        .catch((error) => {
            console.log(error);
            handleAllowTransfer(false);
        });
        
      }

      let[error_transfer,set_error_ransfer]=useState("")
      let[success_transfer,set_success_ransfer]=useState("")
      let[loading_transfer,set_loading_transfer]=useState(false)

      let navigate=useNavigate()

      const Transfer=()=>{
        set_loading_transfer(true)
        let vallues={
          recipantEmail:recipantEmail,
          shopId:shop._id
        }
        console.log(vallues);
        axios
        .post(`${process.env.REACT_APP_URL}/api/shope/sendTransferRequiest`,vallues, {
          headers: {
            Authorization: `Bearer ${propsData.userData?.token}`,
            'Content-Type': 'application/json'

          },
        })
 
        .then((response) => {
          set_loading_transfer(false);
          propsData.setEquilizer(propsData.equilizer+2)
          console.log(response.data);
          handleTransferPage(false)
          set_success_ransfer(response.data?.msg)
          handleAllowTransfer(false)
          setTimeout(() => {
            set_success_ransfer('');
          }, 8000);
          //navigate("/profile/shop")
        })
 
        .catch((error) => {
          set_loading_transfer(false);
          console.error(error);
          if (error.response) {
            set_error_ransfer(error.response.data.error||"Error occured please try again !!!");
          } else {
            set_error_ransfer('An error occurred. Please try again.');
          }
          setTimeout(() => {
            set_error_ransfer('');
          }, 5000);
        });
    }

    const abort=()=>{
      set_loading_transfer(true)
      let vallues={
        shopId:shop._id
      }
      axios
      .put(`${process.env.REACT_APP_URL}/api/shope/abortOwnership`,vallues, {
        headers: {
          Authorization: `Bearer ${propsData.userData?.token}`,
          'Content-Type': 'application/json'

        },
      })

      .then((response) => {
        set_loading_transfer(false);
        propsData.setEquilizer(propsData.equilizer+2)
        console.log(response.data);
        handleTransferPage(false)
        set_success_ransfer(response.data?.msg)
        handleAbortPage(false)
        setTimeout(() => {
          set_success_ransfer('');
        }, 8000);
        //navigate("/profile/shop")
      })

      .catch((error) => {
        set_loading_transfer(false);
        console.error(error);
        if (error?.response) {
          set_error_ransfer(error?.response?.data?.error||"Error occured please try again !!!");
        } else {
          set_error_ransfer('An error occurred. Please try again.');
        }
        setTimeout(() => {
          set_error_ransfer('');
        }, 5000);
      });

    }

       let[error_delete,set_error_delete]=useState("")
      let[loading_delete,set_loading_delete]=useState(false)

    const DeleteShop=()=>{
      set_loading_delete(true)
    
      axios
      .delete(`${process.env.REACT_APP_URL}/api/shope/delete/${shop._id}`, {
        headers: {
          Authorization: `Bearer ${propsData.userData?.token}`,
          'Content-Type': 'application/json'

        },
      })

      .then((response) => {
        set_loading_delete(false);
        propsData.setEquilizer(propsData.equilizer+2)
        console.log(response.data);
        propsData.handleCurrentShope(propsData.userShope[0])
        window.location.href = "/profile/shop";
        //navigate("/profile/shop")
      })

      .catch((error) => {
        set_loading_delete(false);
        console.error(error);
        if (error?.response) {
          set_error_delete(error?.response?.data?.error||"Error occured please try again !!!");
        } else {
          set_error_delete('An error occurred. Please try again.');
        }
        setTimeout(() => {
          set_error_delete('');
        }, 6000);
      });
      }

//      console.log(shop_adress);
    return (
        <div className="shop-settings-whole-container">
            <div className="shop-settings-title">General</div>
            <div className="shop-settings-profile">
               
                <ShopProfilePicture propsData={propsData} shop={shop}/>
                <div className="shop-settings-profile-body">
                    <div  className="shop-settings-profile-body-form">
                       <div className="shop-settings-profile-body-each">  
                                <h4>Shop Name</h4>
                                <div><Input value={shop_name} onChange={(e)=>handle_shop_name(e.target.value)} placeholder="Shop Name" /></div>
                        </div>                        
                        <div className="shop-settings-profile-body-each">  
                                <h4>Shop Type</h4>
                                <div><Input  value={shop_type} onChange={(e)=>handle_shop_type(e.target.value)} placeholder="Shop type" /></div>
                        </div>

                        <div className="shop-settings-profile-body-each">  
                                <h4>Country</h4>
                                <div><Input   value={country} onChange={(e)=>handle_country(e.target.value)} placeholder="Country" /></div>
                        </div>

                        {shop_adress?.name&&<div className="shop-settings-profile-body-shopAdress-show">
                           <div><LocationOnIcon style={{color:"red",fontSize:"50px"}}/></div>
                            <div className="shop-settings-profile-body-shopAdress-status">
                                <div  className="shop-settings-profile-body-shopAdress-status-each">
                                    <div  className="shop-settings-profile-body-shopAdress-status-each-title">Name</div>
                                    <div  className="shop-settings-profile-body-shopAdress-status-each-value">{shop_adress?.name}</div>
                                 </div>

                                 <div  className="shop-settings-profile-body-shopAdress-status-each">
                                    <div  className="shop-settings-profile-body-shopAdress-status-each-title">Latitude</div>
                                    <div  className="shop-settings-profile-body-shopAdress-status-each-value">{shop_adress?.lat}</div>
                                 </div>

                                 <div  className="shop-settings-profile-body-shopAdress-status-each">
                                    <div  className="shop-settings-profile-body-shopAdress-status-each-title">Longitude</div>
                                    <div  className="shop-settings-profile-body-shopAdress-status-each-value">{shop_adress?.lng}</div>
                                 </div>
       

                            </div>
                        </div>}

                        <div className="shop-settings-profile-body-shopAdress">
                           <Button onClick={()=>setShowMap(!showMap)}>{shop_adress?.name?"Change Adress":"Add adress"}</Button>
                        </div>

                        {showMap&&<Map setShowMap={setShowMap} shop_adress={shop_adress} handle_shop_adress={handle_shop_adress} userData={propsData.userData}/>}
                       
                        <div className="shop-settings-profile-body-each">  
                                <h4>Description</h4>
                                <div className="shop-settings-profile-body-each-quill"><ReactQuill modules={modules} style={{height:"180px"}}theme="snow" value={description} onChange={(e)=>handle_description(e)} /></div>
                        </div>

                    </div>
                    
                    <div className="shop-settings-profile-save">
                       {loading?  
                          <CircularProgress size={28}/>
                         : <Button onClick={SaveChanges} disabled={disableSave}>Save Changes</Button>}
                    </div>
         
                    {error&&<div style={{marginTop:"10px",marginBottom:"10px",width:"60%",minWidth:"100px"}}><Alert message={error} type="error" showIcon /> </div>}
                    {success&&<div style={{marginTop:"10px",marginBottom:"10px",width:"60%",minWidth:"100px"}}><Alert message={success} type="success" showIcon /> </div>}

                    <div  className="shop-settings-danger-zone">

                        <div className="shop-settings-danger-zone-title">Danger zone</div>
                        <div  className="shop-settings-danger-zone-body">
                             <div className="shop-settings-danger-zone-body-transfer">
                                 <div>
                                    When transferring ownership of the shop, all permissions and responsibilities will be transferred to the new person. You will not be involved in any matters unless the new owner adds you as an admin.
                                 </div>
                                 <div style={{textAlign:"end",marginTop:"20px"}}>
                                    {checkRequest==="not exist"&&<Button onClick={()=>handleTransferPage(!transferPage)}>Transfer ownership</Button>}
                                    {checkRequest==="pending"&&<Button onClick={()=>handleAbortPage(!abortPage)}>Abort</Button>}
                                    {success_transfer&&<div style={{textAlign:"end",marginBottom:"5px",color:"green"}}>{success_transfer}</div>}
                                 </div>
                             </div>
                             <div className="shop-settings-danger-zone-body-Delete">
                                <div className="shop-settings-danger-zone-body-Delete-text">
                                    If you delete this shop, everything in the shop will be deleted, and there is no way to recover it. This includes:
                                    <ul>
                                        <li>Materials added</li>
                                        <li>Categories created</li>
                                        <li>Posts created</li>
                                        <li>Reviews</li>
                                        <li>And everything else about your shop</li>
                                    </ul>     
                                        <div>Please carefully consider your decision before deleting your shop.</div>

                                </div>
                                <div style={{textAlign:"end",marginTop:"20px"}}>
                                      <Button onClick={()=>handleDeletePage(!deletePage)}>Delete Shop</Button>
                                </div>
                             </div>
                        </div>
                        
                    </div>
               </div>
           </div>
          
           {transferPage&&
              <div className="shop-settings-danger-zone-body-transferPage">
                 <div className="shop-settings-danger-zone-body-transferPage-box">
                             <div className="shop-settings-danger-zone-body-transferPage-title">
                               Enter email that you want to transfer for. please use valid email
                               that had dukana accounnt
                              </div>
                             <div><Input value={recipantEmail} onChange={AddRecipant}/></div>
                              {error_transfer&&<div style={{color:"red",marginTop:"10px"}}>{error_transfer}</div>}
                             <div className="shop-settings-danger-zone-body-transferPage-button">
                                {loading_transfer
                                  ?<CircularProgress/>
                                   :
                                   <>
                                      <div className="shop-settings-danger-zone-body-transferPage-transferButton"><Button disabled={!allowTransfer} onClick={Transfer} >Transfer</Button></div>
                                      <div className="shop-settings-danger-zone-body-transferPage-cancelButton"><Button onClick={()=>handleTransferPage(false)}>Cancel</Button></div>
                                   </>
                                }
                            </div>
                  </div>
                </div>
                  }

            {abortPage&&
              <div className="shop-settings-danger-zone-body-abortPage">
                 <div className="shop-settings-danger-zone-body-abortPage-box">
                     <div className="shop-settings-danger-zone-body-abortPage-title">Are you sure do you want to abort the request ?</div>
                     <div className="shop-settings-danger-zone-body-abortPage-buttons">
                         {loading_transfer?<CircularProgress/>:
                           <>
                              <div className="shop-settings-danger-zone-body-abortPage-cancel" onClick={()=>handleAbortPage(false)}><Button>Cancel</Button> </div>
                              <div className="shop-settings-danger-zone-body-abortPage-go" onClick={abort}><Button>Go</Button> </div>
                           </>
                         }
                     </div>
                  </div>

              </div>
             }

            
             {deletePage&&
              <div className="shop-settings-danger-zone-body-deletePage">
                 <div className="shop-settings-danger-zone-body-deletePage-box">
                   <div className="shop-settings-danger-zone-body-deletePage-title">Are you sure do you want to delete</div>
                   <div className="shop-settings-danger-zone-body-deletePage-buttons">
                         {loading_delete?<CircularProgress/>:
                           <>
                              <div className="shop-settings-danger-zone-body-deletePage-go" onClick={DeleteShop}><Button>Delete</Button> </div>
                              <div className="shop-settings-danger-zone-body-deletePage-cancel" onClick={()=>handleDeletePage(false)}><Button>Cancel</Button> </div>
                           </>
                         }
                     </div>
                     {error_delete&&<div style={{color:"red",margin:"5px 0 10px"}}>{error_delete}</div>}
                  </div>
              </div>
             }
        </div>
    )
}

const ShopProfilePicture=({propsData,shop})=>{

    let [loading,setLoading]=useState(false)
    let [errorImage,setErrorImage]=useState(false)
    let [isOpened,handleIsOpened]=useState(shop?.isOpened)

    useEffect(()=>{
        setTimeout(()=>{

            handleIsOpened(shop?.isOpened)
        },2000)
    },[shop])
    
    
    const handleCoverChange=(event)=>{
       
        let file=event.target.files[0]
        // console.log(file);

        if (file.size > 1 * 1024 * 1024) {
            setErrorImage('File size should not exceed 1MB');
            setTimeout(()=>{
                setErrorImage("")
            },5000)
            return;
          }
        if(file?.type?.startsWith('image')){
            setErrorImage(false)
            setLoading(true)
            const formData = new FormData();
            formData.append('file', file); 
            formData.append('id', shop._id); 
          

          axios
            .put(`${process.env.REACT_APP_URL}/api/shope/update`, formData, {
              headers: {
                Authorization: `Bearer ${propsData.userData?.token}`,
                'Content-Type': 'multipart/form-data',
              },
            })

            .then((response) => {
              setLoading(false);
              propsData.setEquilizer(propsData.equilizer+2)
             // console.log(response.data);
            })

            .catch((error) => {
              setLoading(false);
            //  console.error(error);
              if (error.response) {
                setErrorImage(error.response.data.error||"Error occured please try again !!!");
              } else {
                setErrorImage('An error occurred. Please try again.');
              }
              setTimeout(() => {
                setErrorImage('');
              }, 5000);
            });

        }
        else{
            setErrorImage("Please use valid image")
            setTimeout(()=>{
                setErrorImage("")
            },5000)
        }
     }

     const handleOpening=(checked)=>{
        setErrorImage(false)
        setLoading(true)
         let vallues={
            isOpened:checked,
            id:shop._id
         }
         console.log(vallues);
        axios
        .put(`${process.env.REACT_APP_URL}/api/shope/update`, vallues, {
          headers: {
            Authorization: `Bearer ${propsData.userData?.token}`,
            'Content-Type': 'multipart/form-data',
          },
        })

        .then((response) => {
          setLoading(false);
          propsData.setEquilizer(propsData.equilizer+2)
         // console.log(response.data);
          handleIsOpened(!isOpened)
        })

        .catch((error) => {
          setLoading(false);
          //console.error(error);
          if (error.response) {
            setErrorImage(error.response.data.error||"Error occured please try again !!!");
          } else {
            setErrorImage('An error occurred. Please try again.');
          }
          setTimeout(() => {
            setErrorImage('');
          }, 5000);
        });
     }

    return(
        <form   className="shop-settings-profile-picture"  enctype="multipart/form-data">
           <label>
                <input
                type="file"
                accept="image/*"
                onChange={handleCoverChange}
                hidden
                />
                 <div><img alt="profile.pic" width={200} src={shop?.coverPic?.fileUrl} /></div>
                <div>{loading?<CircularProgress size={25}/>:<CameraOutlined style={{fontSize:"25px"}}/>}</div>
            </label>
            <div className="shop-settings-opened">  
                 <Switch checkedChildren="Opened" onChange={handleOpening} unCheckedChildren="Closed" checked={isOpened}/>
            </div>
              
            <div style={{marginTop:"10px",marginBottom:"10px"}}>{errorImage&&<Alert message={errorImage} type="error" showIcon />} </div>

        </form>
    )
}